'use strict';

angular.module('mean.foreman').factory('foremanAdjustCombinedQuantitiesService', ['$filter', 'toaster',
    function($filter, toaster) {

        // Phase reports combines similar items and all quantities are
        // combined and then rounded up for material ordering.  This
        // adjustment needs to be reflected back to all the materials
        // listed in the report.
        var setQuantityValues = function(consolidated_materials, materials, sales_tax) {
            _.each(consolidated_materials, function(consolidated) {
                if(consolidated.plan_code !== 'T&M') {
                    var lots = $filter('unique')(consolidated.lots, 'name');
                    var total = 0;
                    _.each(lots, function(lot) {
                        var adjust_lots = $filter('filter')(materials, {
                            'lot': lot.name, 'name': consolidated.name, 
                            'foreman_note': consolidated.foreman_note,
                            'color_code': consolidated.color_code }, true);

                        _.each(adjust_lots, function(adjust) {
                            total += adjust.quantity;
                        });
                    });

                    var diff_amount = consolidated.quantity - total;

                    if(Math.abs(diff_amount) > 0.01) {
                        var factor = parseFloat(consolidated.quantity / total);

                        _.each(lots, function(lot) {
                            var adjust_lots = $filter('filter')(materials, {
                                'lot': lot.name, 'name': consolidated.name, 
                                'foreman_note': consolidated.foreman_note,
                                'color_code': consolidated.color_code }, true);

                            _.each(adjust_lots, function(adjust) {
                                adjust.quantity *= factor;
                                if(adjust.quantity < 0) {
                                    console.log('adjusted quantity is negative...making it positive');
                                    adjust.quantity = Math.abs(adjust.quantity);
                                }
                                adjust.sub_total = adjust.quantity * adjust.price_per_order;
                                adjust.sales_tax = adjust.sub_total * sales_tax;
                                adjust.total = adjust.sub_total + adjust.sales_tax + 
                                    (adjust.delivery_price * adjust.quantity);
                            });
                        });
                    }
                }
            });
        };

        // var setQuantityValuesOffOriginal = function(consolidated_materials, materials, sales_tax) {
        //     _.each(consolidated_materials, function(consolidated) {
        //         if(consolidated.plan_code !== 'T&M') {
        //             //get the original set
        //             //adjust only if there is a difference
        //             if(Math.abs(consolidated.quantity - consolidated.bid_quantity) > .01) {
        //                 var diff_amount = (consolidated.quantity - consolidated.bid_quantity) 
        //                     / consolidated.lots.length;

        //                 _.each(consolidated.lots, function(lot) {
        //                     var adjust_lots = $filter('filter')(materials, {
        //                         'lot': lot.name, 'name': consolidated.name, 
        //                         'foreman_note': consolidated.foreman_note,
        //                         'color_code': consolidated.color_code }, true);

        //                     _.each(adjust_lots, function(adjust) {
        //                         adjust.quantity += diff_amount;
        //                         adjust.sub_total = adjust.quantity * adjust.price_per_order;
        //                         adjust.sales_tax = adjust.sub_total * sales_tax;
        //                         adjust.total = adjust.sub_total + adjust.sales_tax + 
        //                             (adjust.delivery_price * adjust.quantity);
        //                     });
        //                 });
        //             }
        //         }
        //     });
        // };

        return {
            setQuantityValues: setQuantityValues
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/foreman/public/services/foreman-adjust-combined-quantities-service.js